var orderDetailsMapper = function (response) {
    if (response) {
        return {
            orderDetails: response.ord.map(function (x) {
                return {
                    averagePrice: x.avgPrc,
                    dsQty: x.dsQty,
                    duration: x.dur,
                    exOID: x.exOID,
                    exchange: x.exc,
                    nstReqID: x.nstReqID,
                    orderID: x.ordID,
                    prcTF: x.prcTF,
                    prcTyp: x.prcTyp,
                    productCode: x.prdCode,
                    qtyTF: x.qtyTF,
                    scName: x.scName,
                    status: x.sts,
                    symbolName: x.symName,
                    time: x.tim,
                    triggerPrice: x.trgPrc,
                    tradeType: x.trsTyp,
                    text: x.txt,
                    unFlSz: x.unFlSz,
                };
            }),
        };
    }
};
export default orderDetailsMapper;
